module.exports = __webpack_public_path__ + "static/media/appjection-4.9c6456dd.gif";